import { reactive, toRefs } from "vue";
import {
  useFeatureService,
  FeaturePayload
} from "@/modules/business/feature/featureBusiness";

interface FeatureState {
  features: Array<FeaturePayload>;
  featuresLoaded: boolean;
}

const state = reactive<FeatureState>({
  features: [],
  featuresLoaded: false
});

export const useFeature = () => {
  const loadFeatures = (): Promise<void> => {
    const { data, getFeaturesCliente } = useFeatureService();
    return getFeaturesCliente().then(() => {
      state.features = data.value ?? [];
      state.featuresLoaded = true;
    });
  };

  const clearFeatures = (): void => {
    state.features = [];
    state.featuresLoaded = false;
  };

  const isFeatureHabilitada = (idFeature: number): boolean => {
    const feature = state.features.find((f) => f.idFeature === idFeature);
    return !!feature?.habilitada;
  };

  return {
    loadFeatures,
    clearFeatures,
    isFeatureHabilitada,
    ...toRefs(state)
  };
};
